// extracted by mini-css-extract-plugin
module.exports = {"d1ofh7ot":"d1ofh7ot"};